import axios from 'axios'
import { CONFIG } from '../config'
import { format } from 'date-fns'

export const axiosInstance = axios.create({
  baseURL: CONFIG.apiUrl,
})

axiosInstance.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
axiosInstance.defaults.withCredentials = true;
axiosInstance.interceptors.response.use(response => response, error => {
    return new Promise((resolve, reject) => {
        try {
            let csrfRequestUrl = '/api/csrf'
            console.log(error);
            if (
                error
                && error.response
                && error.response.status === 401
            ) {
                console.log(CONFIG.loginUrl)
                location.href = CONFIG.loginUrl
                return
            }

            if (
                error
                && error.response
                && error.response.status === 419
                && error.config.url !== csrfRequestUrl
                && !error.config.retried
            ) {
                axiosInstance.get(csrfRequestUrl).then(response => {
                    if (response.data.token) {
                        axiosInstance.defaults.headers.common['X-CSRF-TOKEN'] = response.data.token
                        error.config.headers['X-CSRF-TOKEN'] = response.data.token
                        error.config.retried = true
                        axiosInstance.request(error.config).then(resolve).catch(reject)
                        return
                    }
                    reject(error)
                }).catch(() => reject(error))
            } else {
                reject(error)
            }
        } catch (e) {
            return reject(error)
        }
    })
});
const Api = {
  getOrders: (date) => {
    return new Promise((resolve) => {
      axiosInstance
        .get('orders?date=' + date)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          console.log('getOrders ERROR', error.response.data)
          resolve([])
        })
    })
  },
  completeOrder: (orderId) => {
    return new Promise((resolve) => {
      axiosInstance
        .post(`orders/${orderId}/complete`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          console.log('completeOrder ERROR', error.response.data)
          resolve([])
        })
    })
  },
  uncompleteOrder: (orderId) => {
    return new Promise((resolve) => {
      axiosInstance
        .post(`orders/${orderId}/uncomplete`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          console.log('uncompleteOrder ERROR', error.response.data)
          resolve([])
        })
    })
  },
  updateOrderStatus: (orderId, status, changeCashRegisterSend) => {
    return new Promise((resolve) => {
      axiosInstance
        .patch(`orders/${orderId}/status`, {
            status: status,
            changeCashRegisterSend: changeCashRegisterSend,
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          console.log('order status update ERROR', error.response.data)
          resolve([])
        })
    })
  },
  getOrderCount: (dates) => {
    return new Promise((resolve) => {
      axiosInstance
        .get('orders/count', {
          params: {
            dates: dates.map((date) => date.date),
          },
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          console.log('getOrdersCount ERROR', error.response.data)
          resolve([])
        })
    })
  },
  updateOrder: (order) => {
    return new Promise((resolve) => {
      axiosInstance
        .patch(`orders/${order.id}`, order)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          console.log('updateOrder ERROR', error.response.data)
          resolve([])
        })
    })
  },
  updateLocation: (location) => {
    return new Promise((resolve) => {
      axiosInstance
        .patch(`locations/${location.id}`, location)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          resolve([])
        })
    })
  },
  getLocations: () => {
    return new Promise((resolve) => {
      axiosInstance
        .get('locations')
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          resolve([])
        })
    })
  },
  getMenu: () => {
    return new Promise((resolve) => {
      axiosInstance
        .get('menu/waiter')
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          resolve([])
        })
    })
  },
  getOrdersByRange: (dates: any) => {
    return new Promise((resolve) => {
      axiosInstance
        .get('orders', {params: {
            dates: {
                start: format(dates[0], 'yyyy-MM-dd'),
                end: format(dates[1], 'yyyy-MM-dd'),
            }
        }})
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          resolve([])
        })
    })
  },
  createOrder: (order: any) => {
    return new Promise((resolve) => {
      axiosInstance
        .post('kitchen/order', order)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          resolve([])
        })
    })
  },
  updateOrderNotify: (order: any) => {
    return new Promise((resolve) => {
      axiosInstance
        .patch(`orders/${order.id}/notify`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          resolve([])
        })
    })
  },
  orderDrinksStart: (order: any) => {
    return new Promise((resolve) => {
      axiosInstance
        .patch(`orders/${order.id}/drinks-start`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          resolve([])
        })
    })
  },
  deleteOrder: (order) => {
    return new Promise((resolve) => {
      axiosInstance
        .delete(`orders/${order.id}`, order)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          console.log('updateOrder ERROR', error.response.data)
          resolve([])
        })
    })
  },
  createReservation: (reservation: any) => {
    // Resolves { ok: true } on success, { ok: false, blocked: true, reason } when
    // the backend refused because of a reservation block (HTTP 409), or
    // { ok: false } on any other error. Never rejects (keeps old callers safe).
    return new Promise((resolve) => {
      const data = reservation;
      if (typeof reservation.date === 'object') {
        data.date = format(reservation.date, 'yyyy-MM-dd')
      }
      axiosInstance
        .post('kitchen/reservation', data)
        .then((response) => {
          resolve({ ok: true, data: response.data })
        })
        .catch((error) => {
          if (error && error.response && error.response.status === 409 && error.response.data) {
            resolve({ ok: false, blocked: true, reason: error.response.data.reason, block: error.response.data.block })
            return
          }
          console.log('createReservation ERROR', error && error.response ? error.response.data : error)
          resolve({ ok: false })
        })
    })
  },
  getBlocks: (dates: any) => {
    // dates: [start, end] (Date or 'yyyy-MM-dd' strings)
    const fmt = (d: any) => (typeof d === 'string' ? d : format(d, 'yyyy-MM-dd'))
    return new Promise((resolve) => {
      axiosInstance
        .get('kitchen/blocks', {
          params: {
            dates: {
              start: fmt(dates[0]),
              end: fmt(dates[1]),
            }
          }
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          console.log('getBlocks ERROR', error && error.response ? error.response.data : error)
          resolve([])
        })
    })
  },
  createBlock: (block: any) => {
    return new Promise((resolve) => {
      const data = { ...block }
      for (const key of ['date_from', 'date_to']) {
        if (data[key] && typeof data[key] === 'object') {
          data[key] = format(data[key], 'yyyy-MM-dd')
        }
      }
      axiosInstance
        .post('kitchen/block', data)
        .then((response) => {
          resolve({ ok: true, data: response.data })
        })
        .catch((error) => {
          console.log('createBlock ERROR', error && error.response ? error.response.data : error)
          const data = error && error.response ? error.response.data : null
          resolve({ ok: false, message: data ? data.message : null })
        })
    })
  },
  deleteBlock: (id) => {
    return new Promise((resolve) => {
      axiosInstance
        .delete(`kitchen/blocks/${id}`)
        .then((response) => {
          resolve({ ok: true })
        })
        .catch((error) => {
          console.log('deleteBlock ERROR', error && error.response ? error.response.data : error)
          resolve({ ok: false })
        })
    })
  },
  getReservationsCount: (dates) => {
    return new Promise((resolve) => {
      axiosInstance
        .get('kitchen/reservations/count', {
          params: {
            dates: dates.map((date) => date.date),
          },
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          console.log('getReservationCount ERROR', error.response.data)
          resolve([])
        })
    })
  },
  getReservations: (date) => {
    return new Promise((resolve) => {
      axiosInstance
        .get('kitchen/reservations?date=' + date)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          console.log('getReservations ERROR', error.response.data)
          resolve([])
        })
    })
  },
  getReservationsByRange: (dates: any) => {
    return new Promise((resolve) => {
      axiosInstance
        .get('kitchen/reservations', {
          params: {
            dates: {
              start: format(dates[0], 'yyyy-MM-dd'),
              end: format(dates[1], 'yyyy-MM-dd'),
            }
          }
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          resolve([])
        })
    })
  },
  deleteReservation: (id) => {
    return new Promise((resolve) => {
      axiosInstance
        .delete(`kitchen/reservations/${id}`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          console.log('deleteReservation ERROR', error.response.data)
          resolve([])
        })
    })
  },
  getAllReservations: (dates: any) => {
    return new Promise((resolve) => {
      axiosInstance
        .get('kitchen/reservations/all', {
          params: {
            dates: {
              start: format(dates[0], 'yyyy-MM-dd'),
              end: format(dates[1], 'yyyy-MM-dd'),
            }
          }
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          resolve([])
        })
    })
  },
  getCalendarReservations: (dates: any) => {
    return new Promise((resolve) => {
      axiosInstance
        .get('kitchen/reservations/calendar')
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          resolve([])
        })
    })
  },
  getPendingAction: () => {
    return new Promise(resolve => {
      axiosInstance.get('actions').then((response) => {
        resolve(response.data)
      }).catch((error) => {
        console.log('actions ERROR', error.response.data);
        resolve([])
      })
    })
  },
  saveAction: (id, actions) => {
    return new Promise(resolve => {
      axiosInstance.post('actions', {
        id,
        actions
      }).then((response) => {
        resolve(response.data)
      }).catch((error) => {
        console.log('actions ERROR', error.response.data);
        resolve([])
      })
    })
  },
  getCallWaiter: () => {
    return new Promise(resolve => {
      axiosInstance.get('call-waiter-active',).then((response) => {
        resolve(response.data)
      }).catch((error) => {
        console.log('actions ERROR', error.response.data);
        resolve([])
      })
    })
  },
  dismissWaiterCalled: () => {
    return new Promise(resolve => {
      axiosInstance.post('dismiss-waiter-called',).then((response) => {
        resolve(response.data)
      }).catch((error) => {
        console.log('actions ERROR', error.response.data);
        resolve([])
      })
    })
  },
}

export default Api
